import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-deep px-4 pb-10 pt-20 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-[1600px]">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src="/logo-lockup.png" alt="Green Grade" className="h-14 w-auto" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-fog">
              Authorized CHCNAV distributor — 2.5D &amp; 3D machine control for excavators and dozers. Installed,
              calibrated and supported by Green Grade.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal">Systems</p>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/products/2.5d" data-testid="footer-link-25d" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  EasyNAV EMG100 — 2.5D
                </Link>
              </li>
              <li>
                <Link to="/products/3d" data-testid="footer-link-3d" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  MCNAV TX73 — 3D
                </Link>
              </li>
              <li>
                <Link to="/compare" data-testid="footer-link-compare" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  2D vs 2.5D vs 3D
                </Link>
              </li>
              <li>
                <Link to="/products/dozer" data-testid="footer-link-dozer" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  TD63 Pro — Dozer
                </Link>
              </li>
              <li>
                <Link to="/products/rover" data-testid="footer-link-rover" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  i83 — Survey Rover
                </Link>
              </li>
              <li>
                <Link to="/specifications" data-testid="footer-link-specs" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  Spec sheets
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal">Company</p>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/" data-testid="footer-link-home" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/precision-solutions" data-testid="footer-link-precision" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  Why CHCNAV
                </Link>
              </li>
              <li>
                <Link to="/work" data-testid="footer-link-proof" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  Field proof
                </Link>
              </li>
              <li>
                <Link to="/hire" data-testid="footer-link-hire" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  3D on demand — hire
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="inline-block py-1 text-sm text-fog transition-colors hover:text-neon">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-demo" className="inline-flex items-center gap-1 text-sm text-neon">
                  Request a demo <ArrowUpRight className="h-3.5 w-3.5" />
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal">Contact</p>
            <ul className="mt-5 space-y-3 font-mono text-xs text-fog">
              <li>
                <a href="tel:+611300277689" data-testid="footer-phone-link" className="inline-block py-1 transition-colors hover:text-neon">
                  Sales &amp; support: 1300 277 689
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-line pt-6 font-mono text-[10px] uppercase tracking-[0.22em] text-fog/70 sm:flex-row">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Green Grade — Authorized CHCNAV distributor</span>
          <span>
            CHCNAV is a trademark of{" "}
            <a href="https://www.chcnav.com" target="_blank" rel="noopener noreferrer" data-testid="footer-chcnav-official-link" className="inline-block py-1 underline decoration-signal/40 underline-offset-4 transition-colors hover:text-neon">
              CHC Navigation
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
